import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Pagination, Autoplay, Scrollbar } from "swiper/modules"; // Correct import path for Swiper modules

// Import Swiper styles

import "swiper/css/scrollbar";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { FaQuoteRight } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";



// Testimonial data
const testimonials = [
  {
    quote: " Quality Work and Outstanding Service! I’ve worked with many contractors over the years, but this team really stands out. Their knowledge of DEWA regulations was spot on, and they made the approval process incredibly smooth. The work itself was done with precision and professionalism. We’ll definitely be using them for future projects!",
    name: "Bala Saran",
    title: "Entrepreneur"
  },
  {
    quote: "Megavolt Technical Services Co. LLC is a reliable contractor. They consistently deliver on their promises and meet project deadlines.i appreciate their hardwork and acknowledge their performance",
    name: "Mohamed Thanveer",
    title: "Marketing Manager"
  },
  {
    quote: "Great communication, reliable and honest people. Mubaris and Rowfi and his team were very professional, and he responded to my messages promptly and even at times way outside his work hours.",
    name: "Gopi Goz",
    title: "CEO"
  },
  {
    quote: "One Of The Best Maintenance Company In Dubai ,UAE",
    name: "Dhanushkumar Narayanan",
    title: "Entrepreneur"
  },
  {
    quote: "Best company for electrical approvals and electrical related works.",
    name: "Jagathis T",
    title: "Marketing Manager"
  },
  {
    quote: "We had a fantastic experience working with this company for our DEWA approvals. From start to finish, the process was smooth, professional, and incredibly efficient.",
    name: "Muthu vignesh",
    title: "Marketing Manager"
  },
];

const Testimonial = () => {
  return (
    <div className='p-3 md:py-6'>
      <div className="text-center my-2">
        <h1 className="font-bold text-2xl md:text-3xl text-center uppercase">What Clients Say</h1>
      </div>
      <p className="text-center text-orange lg:text-2xl text-xl ">
        We care about our clients, so we are popular
      </p>
      <div className="md:my-10 my-8">
      <Swiper
              pagination={{
                dynamicBullets: true,
                
              }}
              autoplay={{
                delay: 3000, // Delay between slides in milliseconds
                disableOnInteraction: false, // Keep autoplay even when interacted
              }}
              loop={true} // Loop the slides continuously
              speed={1200} // Adjust for smoothness
             
              modules={[Pagination, Autoplay]}
         
        
          className="mySwiper"
          slidesPerView={1}
          spaceBetween={30}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 50,
            },
          }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide className='p-4' key={index}>
              <div className=' mb-8 shadow-[0_5px_20px_#01010145] p-5 rounded-xl'>
                <div className='text-center shadow-[0_1rem_3rem_rgba(0, 0, 0, .18)]'>
                  <div className='flex items-center justify-center'>
                    <CgProfile className='text-orange text-[40px] mb-5' />
                  </div>
                  <p className='text-center md:text-lg text-base'>
                    {testimonial.quote}
                  </p>
                  <h1 className='text-center font-bold mt-3'>
                    {testimonial.name}
                  </h1>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonial;
